import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import {HookedBrowserRouter, navigate} from "./utils/router";
import {applyMiddleware, createStore} from "redux";
import {rootReducer} from "./reducers";
import thunk, {ThunkMiddleware} from "redux-thunk";
import {RootState} from "./types";
import {RootAction} from "./actions";
import logger from "redux-logger";
import {defaultLocale, translations} from "./locale";
import {Provider as ReduxProvider} from 'react-redux';
import {AUTH0_AUDIENCE, AUTH0_CLIENT_ID, AUTH0_DOMAIN, STRIPE_KEY} from "./utils/constants";
import {loadTranslations, setLocale, syncTranslationWithStore} from "react-redux-i18n";
import {Auth0Provider} from "@auth0/auth0-react";
import {AppState} from "@auth0/auth0-react/dist/auth0-provider";
import {KAlertProvider} from "@kopjra/uikit";
import App from "./containers/App";
import countries from "i18n-iso-countries";

import './index.scss';
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js/pure";

// Creating the REDUX Store
export const store = createStore(rootReducer, applyMiddleware(thunk as ThunkMiddleware<RootState, RootAction>, logger));

// Configuring Locale Management
syncTranslationWithStore(store);
store.dispatch(loadTranslations(translations));
store.dispatch(setLocale(defaultLocale));

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("i18n-iso-countries/langs/it.json"));

// Customizing Auth0 Callback handling using the custom router
const onRedirectCallback = (appState?: AppState) => {
    // Use the router's history module to replace the url
    navigate(appState?.returnTo || window.location.pathname, {replace: true});
};

const stripePromise = loadStripe(STRIPE_KEY || "", {locale: defaultLocale});

ReactDOM.render(
  <React.StrictMode>
      <ReduxProvider store={store}>
          <Auth0Provider
              onRedirectCallback={onRedirectCallback}
              domain={AUTH0_DOMAIN}
              clientId={AUTH0_CLIENT_ID}
              redirectUri={window.location.origin}
              audience={AUTH0_AUDIENCE}
          >
              <HookedBrowserRouter>
                  <KAlertProvider timeout={5000}>
                      <Elements stripe={stripePromise}>
                          <App/>
                      </Elements>
                  </KAlertProvider>
              </HookedBrowserRouter>
          </Auth0Provider>
      </ReduxProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
